import ModalsInfoLib from '../../lib/modals-info';

export default () => {
    return (
        <div className="modal-info-container">
            <div className="modal-info animate__animated animate__fadeInUp animate__faster">
                <div className="close-button" onClick={e => ModalsInfoLib.close()}>
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M6 18L18 6" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M18 18L6 6" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </div>

                <div className="modal-info-content">
                    <div className="modal-info-image">
                        <img src={`${window.location.origin}/source/system/modal-info/vip-20-birthday-bonus-info.png`} alt="" />
                    </div>

                    <div className="modal-info-body">
                        <div className="modal-info-body-content">
                            <p>
                                <h1>Birthday Bonus</h1>

                                <span>Celebrate your special day with an exclusive reward from Lucksy.</span>
                                <span>To unlock your Birthday Bonus, you must complete full KYC verification in your profile.</span>
                                <span>Your bonus will be available on your birthday and can be claimed within <b>7 days</b>.</span>
                                <span>You will receive a fixed bonus to your balance, along with a deposit boost active for <b>7 days</b>.</span>
                            </p>

                            <p>
                                <h2>Rewards by VIP Level</h2>
                                <span>
                                    Regular — <b>$5</b> + <b>10%</b> deposit boost<br/>
                                    Bronze — <b>$10</b> + <b>10%</b> deposit boost<br/>
                                    Silver — <b>$15</b> + <b>10%</b> deposit boost<br/>
                                    Gold — <b>$15</b> + <b>15%</b> deposit boost<br/>
                                    Platinum — <b>$20</b> + <b>17%</b> deposit boost<br/>
                                    Diamond — <b>$25</b> + <b>20%</b> deposit boost<br/>
                                    Elite — <b>$50</b> + <b>20%</b> deposit boost
                                </span>
                            </p>

                            <p>
                                <h2>How does Deposit Boost work?</h2>
                                <span>The deposit boost works similarly to Random Boost and always overrides any other deposit bonuses.</span>
                                <span>It cannot be combined with other promotions.</span>
                                <span>The bonus percentage is applied to the final deposit amount after any fees.</span>
                            </p>
                        </div>
                    </div>
                </div>
            </div>

            <div className="modal-info-overlay animate__animated animate__fadeIn animate__faster"></div>
        </div>
    )
}